import React from 'react';

const MapEmbed = ({ location }) => {
  if (!location) {
    return null;
  }
  const encodedLocation = encodeURIComponent(location);
  const cacheBust = `&_=${new Date().getTime()}`;
  const src = `https://nk2lgsxkwf.execute-api.us-east-1.amazonaws.com/prod/google-maps-embed?location=${encodedLocation}${cacheBust}`;

  return (
    <div className="filter-map">
      <iframe
        width="600"
        height="250"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        title="Interactive map showing selected location"
        key={src} // Key prop ensures iframe reloads only when src changes
        src={src}
      />
    </div>
  );
};

export default React.memo(MapEmbed); 